export default __webpack_public_path__ + "static/media/how_entered_projections.956b9a75.png";